import React from 'react';

interface LoaderProps {
  message?: string;
  fullScreen?: boolean;
  small?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ message = 'Loading...', fullScreen = false, small = false }) => {
  const containerStyle: React.CSSProperties = fullScreen
    ? { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }
    : { padding: '24px 0', display: 'flex', alignItems: 'center', justifyContent: 'center' };

  const spinnerStyle: React.CSSProperties = small
    ? { width: 16, height: 16, borderWidth: 2, marginRight: 8 }
    : { width: 20, height: 20, borderWidth: 2, marginRight: 10 };

  return (
    <div style={containerStyle}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div className="loading-spinner" style={spinnerStyle} />
        <span className="loading-text">{message}</span>
      </div>
    </div>
  );
};

export default Loader;


